import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material";
import { SearchMedicalReportCategory } from "src/app/model/study-report/search-medical-report-category-response";
import { NotificationToastService } from "src/app/services/notification-toast.service";
import { StudyReportService } from "src/app/services/study-report/study-report.service";

@Component({
  selector: "app-study-report-audit-diagnoses-dialog",
  templateUrl: "./study-report-audit-diagnoses-dialog.component.html",
  styleUrls: ["./study-report-audit-diagnoses-dialog.component.css"],
})
export class StudyReportAuditDiagnosesDialogComponent implements OnInit {
  form: FormGroup;
  categories: SearchMedicalReportCategory[] = [];
  loading = false;

  constructor(
    public dialogRef: MatDialogRef<StudyReportAuditDiagnosesDialogComponent>,
    private formBuilder: FormBuilder,
    private studyReportService: StudyReportService,
    private notificationToastService: NotificationToastService,
  ) {
    this.form = this.formBuilder.group({
      category: [null, Validators.required],
    });
  }

  get f() {
    return this.form.controls;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  accept() {
    if (this.form.valid) {
      this.dialogRef.close(this.form.getRawValue().category);
    }
  }

  async ngOnInit() {
    try {
      this.loading = true;
      this.categories = await this.studyReportService.getMedicalReportCategories();
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err && err.error ? err.error : err),
        "Informe auditoría",
      );
    } finally {
      this.loading = false;
    }
  }
}
